import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled, { useTheme } from 'styled-components';
import { Box, Heading, Image, Text, Link } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled(Box).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    $py: theme.header.customerSpotlight.verticalPadding,
    $px: theme.header.customerSpotlight.horizontalPadding,
    $styles: {
      borderRadius: theme.header.highlighted.radius,
      backgroundColor: theme.header.highlighted.background
    }
  };
}).withConfig({
  displayName: "CustomerSpotlight__Container",
  componentId: "sc-617atb-0"
})([""]);
var Blockquote = styled(Text).attrs(function (_ref2) {
  var theme = _ref2.theme;
  return {
    as: 'blockquote',
    $variant: theme.header.customerSpotlight.quote.variant,
    $styles: {
      color: theme.header.colors.secondaryText
    }
  };
}).withConfig({
  displayName: "CustomerSpotlight__Blockquote",
  componentId: "sc-617atb-1"
})(["&:before{content:'\u201C';}&:after{content:'\u201D';}"]);
var Headline = styled(Heading).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    as: theme.header.customerSpotlight.headline.as,
    $mb: theme.header.customerSpotlight.margins.afterHeadline,
    $variant: theme.header.customerSpotlight.headline.variant
  };
}).withConfig({
  displayName: "CustomerSpotlight__Headline",
  componentId: "sc-617atb-2"
})([""]);
var ViewAllLink = styled(Link).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    $variant: theme.header.customerSpotlight.viewAllLink.variant,
    $color: theme.header.customerSpotlight.viewAllLink.color,
    $size: theme.header.customerSpotlight.viewAllLink.size,
    withArrow: theme.header.customerSpotlight.viewAllLink.withArrow
  };
}).withConfig({
  displayName: "CustomerSpotlight__ViewAllLink",
  componentId: "sc-617atb-3"
})([""]);

var CustomerSpotlight = function CustomerSpotlight(props) {
  var title = props.title,
      description = props.description,
      image = props.image,
      logo = props.logo,
      showAllLink = props.showAllLink;

  var _useTheme = useTheme(),
      customerSpotlight = _useTheme.header.customerSpotlight;

  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Headline, {
      children: title
    }), image && /*#__PURE__*/_jsx(Box, {
      $mb: customerSpotlight.margins.afterImage,
      $styles: {
        maxWidth: customerSpotlight.imageWidth
      },
      children: /*#__PURE__*/_jsx(Image, _objectSpread({}, image))
    }), logo && /*#__PURE__*/_jsx(Box, {
      $mb: customerSpotlight.margins.afterLogo,
      $styles: {
        maxWidth: customerSpotlight.logoWidth
      },
      children: /*#__PURE__*/_jsx(Image, _objectSpread({}, logo))
    }), /*#__PURE__*/_jsx(Blockquote, {
      $mb: customerSpotlight.margins.afterQuote,
      children: description
    }), showAllLink && /*#__PURE__*/_jsx(ViewAllLink, {
      href: showAllLink.path,
      children: showAllLink.title
    })]
  });
};

export default CustomerSpotlight;